import { Dropdown } from 'primereact/dropdown';
import MenuSidebar from './MenuSidebar';
import { MenuProvider } from './context/menuContext';
import { useEffect, useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { listByUserIdStorage, listStorage } from 'modules/storage/api';
import { listPermission } from 'modules/permission/api';
import { setPermission } from 'redux/features/permission';
import { infoEmployeeByStore } from 'modules/employee/api';
import { setEmployeeInfo } from 'redux/features/user';
import { useDispatch } from 'react-redux';
export const sidebarModel = [{
    items: [
      {
        id: 5,
        name: 'Trang Chủ',
        sort: 1,
        status: 1,
        created_at: '2023-06-01 10:04:39',
        deleted_at: null,
        updated_at: null,
        icon: 'pi pi-home',
        admin:false,
        route: '/'
      },
      {
        id: 1,
        name: 'Số dư đầu kỳ',
        created_at: '2023-05-29 14:14:02',
        updated_at: null,
        deleted_at: null,
        status: 1,
        category_id: 1,
        sort: 1,
        icon: 'pi pi-home',
        admin:false,
        items: [
          {
            id: 1,
            name: 'Số dư đầu kỳ KH',
            route: '/debit/ListDauKyKh',
            created_at: '2023-05-29 14:14:02',
            updated_at: null,
            deleted_at: null,
            status: 1,
            category_id: 1,
            sort: 1,
          },
          {
            id: 1,
            name: 'Số dư đầu kỳ NCC',
            route: '/debit/ListDauKyNcc',
            created_at: '2023-05-29 14:14:02',
            updated_at: null,
            deleted_at: null,
            status: 1,
            category_id: 1,
            sort: 1,
          },
        ]
      },
      {
        id: 5,
        name: 'Kế toán',
        sort: 1,
        status: 1,
        created_at: '2023-06-01 10:04:39',
        deleted_at: null,
        updated_at: null,
        icon: 'pi pi-home',
        admin:false,
        items: [
          {
            id: 1,
            name: 'Theo dõi số file',
            route: '/ContractFile/list',
            created_at: '2023-05-29 14:14:02',
            updated_at: null,
            deleted_at: null,
            status: 1,
            category_id: 1,
            sort: 1,
          },
          {
            id: 1,
            name: 'Theo dõi file nâng hạ',
            route: '/ContractFile/list-create-nangha',
            created_at: '2023-05-29 14:14:02',
            updated_at: null,
            deleted_at: null,
            status: 1,
            category_id: 1,
            sort: 1,
          },
          {
            id: 1,
            name: 'Theo dõi file giá',
            route: '/ContractFile/list-create-filegia',
            created_at: '2023-05-29 14:14:02',
            updated_at: null,
            deleted_at: null,
            status: 1,
            category_id: 1,
            sort: 1,
          },
          {
            id: 11,
            name: 'Theo dõi vỏ lưu bãi',
            route: '/ContractFile/ListVoLuuBai',
            created_at: '2023-05-29 14:14:02',
            updated_at: null,
            deleted_at: null,
            status: 1,
            category_id: 1,
            sort: 1,
          },
          {
            id: 1,
            name: 'Debit KH các lô hàng không lập file',
            route: '/debit/ListDebitNoFileKH',
            created_at: '2023-05-29 14:14:02',
            updated_at: null,
            deleted_at: null,
            status: 1,
            category_id: 1,
            sort: 1,
          },
          {
            id: 1,
            name: 'Debit các lô hàng NCC',
            route: '/debit/ListDebitNCC',
            created_at: '2023-05-29 14:14:02',
            updated_at: null,
            deleted_at: null,
            status: 1,
            category_id: 1,
            sort: 1
          },
           {
            id: 1,
            name: 'Phiếu cược',
            route: '/debit/ListCuocKeToan',
            created_at: '2023-05-29 14:14:02',
            updated_at: null,
            deleted_at: null,
            status: 1,
            category_id: 1,
            sort: 1,
          },
          {
            id: 1,
            name: 'Phiếu tạm thu',
            route: '/debit/ListTamThuKeToan',
            created_at: '2023-05-29 14:14:02',
            updated_at: null,
            deleted_at: null,
            status: 1,
            category_id: 1,
            sort: 1,
          },
          {
            id: 1,
            name: 'Tính lương',
            route: '/salary/list',
            created_at: '2023-05-29 14:14:02',
            updated_at: null,
            deleted_at: null,
            status: 1,
            category_id: 1,
            sort: 1,
          },
        ]
      },
      {
        id: 1,
        name: 'Giao nhận',
        created_at: '2023-05-29 14:14:02',
        updated_at: null,
        deleted_at: null,
        status: 1,
        category_id: 1,
        sort: 1,
        icon: 'pi pi-home',
        admin:false,
        items: [
          {
            id: 1,
            name: 'Bảng liệt kê chi phí',
            route: '/ContractFile/list-create-bangke',
            created_at: '2023-05-29 14:14:02',
            updated_at: null,
            deleted_at: null,
            status: 1,
            category_id: 1,
            sort: 1,
          },
          {
            id: 1,
            name: 'Danh sách cược',
            route: '/debit/listCuoc',
            created_at: '2023-05-29 14:14:02',
            updated_at: null,
            deleted_at: null,
            status: 1,
            category_id: 1,
            sort: 1,
          },
          {
            id: 1,
            name: 'Danh sách tạm thu',
            route: '/debit/listTamThu',
            created_at: '2023-05-29 14:14:02',
            updated_at: null,
            deleted_at: null,
            status: 1,
            category_id: 1,
            sort: 1,
          },
          {
            id: 1,
            name: 'Yêu cầu hoàn ứng',
            route: '/receipt/listViewChiPhiGiaoNhan',
            created_at: '2023-05-29 14:14:02',
            updated_at: null,
            deleted_at: null,
            status: 1,
            category_id: 1,
            sort: 1,
          },
        ]
      },
      {
        id: 1,
        name: 'Bảng điều xe',
        created_at: '2023-05-29 14:14:02',
        updated_at: null,
        deleted_at: null,
        status: 1,
        category_id: 1,
        sort: 1,
        icon: 'pi pi-home',
        admin:false,
        items: [
          {
            id: 1,
            name: 'Nhật ký hàng ngày',
            route: '/ContractFile/list-create-dispatch',
            created_at: '2023-05-29 14:14:02',
            updated_at: null,
            deleted_at: null,
            status: 1,
            category_id: 1,
            sort: 1,
          },
          {
            id: 1,
            name: 'Bảng tổng hợp điều xe',
            route: '/page-two',
            created_at: '2023-05-29 14:14:02',
            updated_at: null,
            deleted_at: null,
            status: 1,
            category_id: 1,
            sort: 1,
          },
        ]
      },
        {
        id: 1,
        name: 'Mua-Bán hàng',
        created_at: '2023-05-29 14:14:02',
        updated_at: null,
        deleted_at: null,
        status: 1,
        category_id: 1,
        sort: 1,
        icon: 'pi pi-home',
        admin:false,
        items: [
          {
            id: 1,
            name: 'Mua hàng',
            route: '/debit/ListMuaHang',
            created_at: '2023-05-29 14:14:02',
            updated_at: null,
            deleted_at: null,
            status: 1,
            category_id: 1,
            sort: 1,
          },
          {
            id: 1,
            name: 'Bán hàng',
            route: '/debit/ListBanHang',
            created_at: '2023-05-29 14:14:02',
            updated_at: null,
            deleted_at: null,
            status: 1,
            category_id: 1,
            sort: 1,
          },
        ]
      },
      {
        id: 1,
        name: 'Công nợ',
        created_at: '2023-05-29 14:14:02',
        updated_at: null,
        deleted_at: null,
        status: 1,
        category_id: 1,
        sort: 1,
        icon: 'pi pi-home',
        admin:false,
        items: [
           {
            id: 1,
            name: 'Khách hàng',
            route: '/page-two',
            created_at: '2023-05-29 14:14:02',
            updated_at: null,
            deleted_at: null,
            status: 1,
            category_id: 1,
            sort: 1,
            items: [
                {
                  id: 1,
                  name: 'Công nợ tổng hợp KH',
                  route: '/debit/ListTongHopKH',
                  created_at: '2023-05-29 14:14:02',
                  updated_at: null,
                  deleted_at: null,
                  status: 1,
                  category_id: 1,
                  sort: 1,
                },
                {
                  id: 1,
                  name: 'Công nợ chi tiết KH',
                  route: '/debit/ListChiTietKH',
                  created_at: '2023-05-29 14:14:02',
                  updated_at: null,
                  deleted_at: null,
                  status: 1,
                  category_id: 1,
                  sort: 1,
                },
            ]
          },
          {
            id: 1,
            name: 'Nhà cung cấp',
            created_at: '2023-05-29 14:14:02',
            updated_at: null,
            deleted_at: null,
            status: 1,
            category_id: 1,
            sort: 1,
            items: [
                {
                  id: 1,
                  name: 'Công nợ tổng hợp NCC',
                  route: '/debit/ListTongHopNCC',
                  created_at: '2023-05-29 14:14:02',
                  updated_at: null,
                  deleted_at: null,
                  status: 1,
                  category_id: 1,
                  sort: 1,
                },
                {
                  id: 1,
                  name: 'Công nợ chi tiết NCC',
                  route: '/debit/ListChiTietNCC',
                  created_at: '2023-05-29 14:14:02',
                  updated_at: null,
                  deleted_at: null,
                  status: 1,
                  category_id: 1,
                  sort: 1,
                },
            ]
          },
          {
            id: 1,
            name: 'Bù trừ công nợ',
            route: '/receipt/ListDoiTruCongNo',
            created_at: '2023-05-29 14:14:02',
            updated_at: null,
            deleted_at: null,
            status: 1,
            category_id: 1,
            sort: 1,
          },
          {
            id: 1,
            name: 'Công nợ giao nhận',
            route: '/debit/ListDebitChiTietGiaoNhan',
            created_at: '2023-05-29 14:14:02',
            updated_at: null,
            deleted_at: null,
            status: 1,
            category_id: 1,
            sort: 1,
          },
          {
            id: 1,
            name: 'Công nợ lái xe',
            route: '/debit/ListDebitChiTietLaiXe',
            created_at: '2023-05-29 14:14:02',
            updated_at: null,
            deleted_at: null,
            status: 1,
            category_id: 1,
            sort: 1,
          }
        ]
      },
      {
        id: 1,
        name: 'Theo dõi nhắc nợ',
        created_at: '2023-05-29 14:14:02',
        updated_at: null,
        deleted_at: null,
        status: 1,
        category_id: 1,
        sort: 1,
        icon: 'pi pi-home',
        admin:false,
        items: [
          {
            id: 1,
            name: 'Kỳ công nợ KH',
            route: '/debit/ListKyCongNoKH',
            created_at: '2023-05-29 14:14:02',
            updated_at: null,
            deleted_at: null,
            status: 1,
            category_id: 1,
            sort: 1,
          },
          {
            id: 1,
            name: 'Nhắc nợ KH',
            route: '/debit/ListNhacNoKH',
            created_at: '2023-05-29 14:14:02',
            updated_at: null,
            deleted_at: null,
            status: 1,
            category_id: 1,
            sort: 1,
          },
          {
            id: 1,
            name: 'Kỳ công nợ NCC',
            route: '/page-two',
            created_at: '2023-05-29 14:14:02',
            updated_at: null,
            deleted_at: null,
            status: 1,
            category_id: 1,
            sort: 1,
          },
          {
            id: 1,
            name: 'Nhắc nợ NCC',
            route: '/page-two',
            created_at: '2023-05-29 14:14:02',
            updated_at: null,
            deleted_at: null,
            status: 1,
            category_id: 1,
            sort: 1,
          },
        ]
      },
      {
        id: 1,
        name: 'Thủ quỹ',
        created_at: '2023-05-29 14:14:02',
        updated_at: null,
        deleted_at: null,
        status: 1,
        category_id: 1,
        sort: 1,
        icon: 'pi pi-home',
        admin:false,
        items: [
         {
            id: 1,
            name: 'Hoàn ứng giao nhận',
            route: '/receipt/listChiPhiGiaoNhan',
            created_at: '2023-05-29 14:14:02',
            updated_at: null,
            deleted_at: null,
            status: 1,
            category_id: 1,
            sort: 1,
          }
        ]
      },
        {
        id: 1,
        name: 'Báo cáo',
        created_at: '2023-05-29 14:14:02',
        updated_at: null,
        deleted_at: null,
        status: 1,
        category_id: 1,
        sort: 1,
        icon: 'pi pi-home',
        admin:false,
        items: [
         {
            id: 1,
            name: 'Báo cáo sổ quỹ tài khoản',
            route: '/receipt/ListBaoCaoTaiKhoan',
            created_at: '2023-05-29 14:14:02',
            updated_at: null,
            deleted_at: null,
            status: 1,
            category_id: 1,
            sort: 1,
          },
         {
            id: 1,
            name: 'Báo cáo sổ quỹ tiền mặt',
            route: '/receipt/ListBaoCaoTienMat',
            created_at: '2023-05-29 14:14:02',
            updated_at: null,
            deleted_at: null,
            status: 1,
            category_id: 1,
            sort: 1,
          },
         {
            id: 1,
            name: 'Báo cáo kết quả kinh doanh',
            route: '/receipt/ListBaoCaoLoiNhuan',
            created_at: '2023-05-29 14:14:02',
            updated_at: null,
            deleted_at: null,
            status: 1,
            category_id: 1,
            sort: 1,
          },
          {
              id: 1,
              name: 'Báo cáo lưu chuyển tiền tệ',
              route: '/receipt/ListBaoCaoLuuChuyenTienTe',
              created_at: '2023-05-29 14:14:02',
              updated_at: null,
              deleted_at: null,
              status: 1,
              category_id: 1,
              sort: 1,
            },
          {
              id: 1,
              name: 'Báo cáo lợi nhuận theo xe',
              route: '/receipt/ListLoiNhuanTheoXe',
              created_at: '2023-05-29 14:14:02',
              updated_at: null,
              deleted_at: null,
              status: 1,
              category_id: 1,
              sort: 1,
            },
          {
              id: 1,
              name: 'Báo cáo các loại phí',
              route: '/debit/BaoCaoNhatKy',
              created_at: '2023-05-29 14:14:02',
              updated_at: null,
              deleted_at: null,
              status: 1,
              category_id: 1,
              sort: 1,
            },
          {
              id: 1,
              name: 'Báo cáo chi tiết thu chi',
              route: '/receipt/BaoCaoChiTietThuChi',
              created_at: '2023-05-29 14:14:02',
              updated_at: null,
              deleted_at: null,
              status: 1,
              category_id: 1,
              sort: 1,
            }
        ]
      },
       {
        id: 5,
        name: 'Quỹ - Ngân Hàng',
        sort: 1,
        status: 1,
        created_at: '2023-06-01 10:04:39',
        deleted_at: null,
        updated_at: null,
        icon: 'pi pi-home',
        admin:false,
        items: [
          {
              id: 5,
              name: 'Số dư tài khoản',
              route: '/receipt/ListDauKyTaiKhoan',
              category_id:1,
              sort: 1,
              status: 1,
              created_at: '2023-06-01 10:04:39',
              deleted_at: null,
              updated_at: null,
          },
          {
            id: 1,
            name: 'Phiếu thu',
            route: '/receipt/ListReceiptThu',
            created_at: '2023-05-29 14:14:02',
            updated_at: null,
            deleted_at: null,
            status: 1,
            category_id: 1,
            sort: 1,
          },
          {
            id: 1,
            name: 'Phiếu chi',
            route: '/receipt/ListReceiptChi',
            created_at: '2023-05-29 14:14:02',
            updated_at: null,
            deleted_at: null,
            status: 1,
            category_id: 1,
            sort: 1,
          },
           {
              id: 4,
              name: 'Chuyển tiền nội bộ',
              route: '/receipt/ListChuyenTienNoiBo',
              sort: 1,
              status: 1,
              created_at: '2023-06-01 10:04:39',
              deleted_at: null,
              updated_at: null,
          }
        ]
      },
       {
        id: 5,
        name: 'Khấu Hao',
        sort: 1,
        status: 1,
        created_at: '2023-06-01 10:04:39',
        deleted_at: null,
        updated_at: null,
        icon: 'pi pi-home',
        admin:false,
        items: [
          {
            id: 1,
            name: 'Tài Sản',
            route: '/depreciation/list',
            created_at: '2023-05-29 14:14:02',
            updated_at: null,
            deleted_at: null,
            status: 1,
            category_id: 1,
            sort: 1,
          },
          {
            id: 1,
            name: 'Chi Phí Chung',
            route: '/depreciation/ListChiPhiChung',
            created_at: '2023-05-29 14:14:02',
            updated_at: null,
            deleted_at: null,
            status: 1,
            category_id: 1,
            sort: 1,
          },
          //  {
          //   id: 1,
          //   name: 'Chi Phí Trả Trước',
          //   route: '/depreciation/ListChiPhiTraTruoc',
          //   created_at: '2023-05-29 14:14:02',
          //   updated_at: null,
          //   deleted_at: null,
          //   status: 1,
          //   category_id: 1,
          //   sort: 1,
          // }
        ]
      },
      {
        id: 5,
        name: 'Danh mục',
        sort: 1,
        status: 1,
        created_at: '2023-06-01 10:04:39',
        deleted_at: null,
        updated_at: null,
        icon: 'pi pi-home',
        admin:false,
        items: [
          {
            id: 1,
            name: 'Đối tác',
            route: '/partner/list',
            created_at: '2023-05-29 14:14:02',
            updated_at: null,
            deleted_at: null,
            status: 1,
            category_id: 1,
            sort: 1,
          },
          {
            id: 1,
            name: 'Quản lý xe',
            route: '/vehicle/list',
            created_at: '2023-05-29 14:14:02',
            updated_at: null,
            deleted_at: null,
            status: 1,
            category_id: 1,
            sort: 1,
          },
          {
            id: 1,
            name: 'Danh mục thu chi',
            route: '/page-two',
            created_at: '2023-05-29 14:14:02',
            updated_at: null,
            deleted_at: null,
            status: 1,
            category_id: 1,
            sort: 1,
            items: [
              {
                id: 1,
                name: 'Thu',
                route: '/categories/ListDanhMucThu',
                created_at: '2023-05-29 14:14:02',
                updated_at: null,
                deleted_at: null,
                status: 1,
                category_id: 1,
                sort: 1,
              },
              {
                id: 1,
                name: 'Chi',
                route: '/categories/ListDanhMucChi',
                created_at: '2023-05-29 14:14:02',
                updated_at: null,
                deleted_at: null,
                status: 1,
                category_id: 1,
                sort: 1,
              },
            ]
          },
          {
            id: 1,
            name: 'Danh sách tài khoản NH',
            route: '/bank/list',
            created_at: '2023-05-29 14:14:02',
            updated_at: null,
            deleted_at: null,
            status: 1,
            category_id: 1,
            sort: 1,
          },
          {
            id: 1,
            name: 'Bộ phận',
            route: '/department/list',
            created_at: '2023-05-29 14:14:02',
            updated_at: null,
            deleted_at: null,
            status: 1,
            category_id: 1,
            sort: 1,
          },
          {
            id: 1,
            name: 'Nhân viên',
            route: '/employee/list',
            created_at: '2023-05-29 14:14:02',
            updated_at: null,
            deleted_at: null,
            status: 1,
            category_id: 1,
            sort: 1,
          },
        ]
      },
      {
        id: 5,
        name: 'Quản lý',
        sort: 1,
        status: 1,
        created_at: '2023-06-01 10:04:39',
        deleted_at: null,
        updated_at: null,
        icon: 'pi pi-home',
        admin:false,
        items: [
          {
            id: 1,
            name: 'Duyệt file giá',
            route: '/ContractFile/list-confirm-filegia',
            created_at: '2023-05-29 14:14:02',
            updated_at: null,
            deleted_at: null,
            status: 1,
            category_id: 1,
            sort: 1,
          },
          {
            id: 1,
            name: 'Duyệt chi phí hải quan',
            route: '/ContractFile/list-confirm-bangke',
            created_at: '2023-05-29 14:14:02',
            updated_at: null,
            deleted_at: null,
            status: 1,
            category_id: 1,
            sort: 1,
          },
          {
            id: 1,
            name: 'Xác nhận chi phí lái xe',
            route: '/receipt/ListXNChiPhiLaiXe',
            created_at: '2023-05-29 14:14:02',
            updated_at: null,
            deleted_at: null,
            status: 1,
            category_id: 1,
            sort: 1,
          }
        ]
      },
      {
        id: 5,
        name: 'Phân quyền',
        sort: 1,
        status: 1,
        created_at: '2023-06-01 10:04:39',
        deleted_at: null,
        updated_at: null,
        icon: 'pi pi-home',
        admin:false,
          items: [
            {
              id: 1,
              name: 'Danh sách quyền',
              route: '/permission',
              created_at: '2023-05-29 14:14:02',
              updated_at: null,
              deleted_at: null,
              status: 1,
              category_id: 1,
              sort: 1,
            }
          ]
      },
      {
        id: 1,
        name: 'Quản lý dữ liệu',
        sort: 2,
        status: 1,
        created_at: '2023-05-29 14:13:14',
        deleted_at: null,
        updated_at: null,
        icon: 'pi pi-home',
        admin:true,
        items: [
          {
            id: 1,
            name: 'Danh sách dữ liệu',
            route: '/storage/list',
            created_at: '2023-05-29 14:14:02',
            updated_at: null,
            deleted_at: null,
            status: 1,
            category_id: 1,
            sort: 1,
          },
        ]
      },
      {
        id: 1,
        name: 'Hệ thống',
        sort: 2,
        status: 1,
        created_at: '2023-05-29 14:13:14',
        deleted_at: null,
        updated_at: null,
        icon: 'pi pi-user',
        admin:true,
        items: [
          {
            id: 1,
            name: 'Người dùng',
            route: '/user/list',
            created_at: '2023-05-29 14:14:02',
            updated_at: null,
            deleted_at: null,
            status: 1,
            category_id: 1,
            sort: 1,
          },
          {
            id: 1,
            name: 'Import đối tác',
            route: '/user/inportExcelPartner',
            created_at: '2023-05-29 14:14:02',
            updated_at: null,
            deleted_at: null,
            status: 1,
            category_id: 1,
            sort: 1,
          },
          {
            id: 2,
            name: 'Cấu hình email',
            route: '/page-two',
            created_at: '2023-05-29 14:14:02',
            updated_at: null,
            deleted_at: null,
            status: 1,
            category_id: 1,
            sort: 2,
          }
        ]
      }
    ]
}];
export default function AppSidebar() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedCity, setSelectedCity] = useState<any>(null);
  const [data, setData] = useState<any[]>([]);
  const [permission, setPermission] = useState<any[]>([]);
  const dispatch = useDispatch();
  const employeeInfo = localStorage.getItem("employeeInfo")
    ? JSON.parse(localStorage.getItem("employeeInfo") || "{}")
    : null;

  // =========================
  // 1) Fetch project list
  // =========================
  const fetchProject = async (userId: number) => {
    try {
      let res: any;

      if ([280].includes(employeeInfo?.user_id)) {
        res = await listStorage({});
      } else {
        res = await listByUserIdStorage({ UserId: userId });
      }

      if (res?.data?.data?.data) {
        const projects = res.data.data.data.map((item: any) => ({
          name: item.name,
          projectId: item.id,
        }));

        setData(projects);
        return projects;
      }

      setData([]);
      return [];
    } catch (err) {
      setData([]);
      return [];
    }
  };

  // =========================
  // 2) Set default project
  // =========================
  const applyDefaultProject = async (projects: any[]) => {
    if (!projects?.length) return;

    const localProject = JSON.parse(localStorage.getItem("project") || "{}");
    const projectIds = projects.map(p => p.projectId);

    let selected = localProject && projectIds.includes(localProject.projectId)
      ? localProject
      : projects[0];
    const emp = await infoEmployeeByStore({UserId: employeeInfo.user_id, StoreId: selected.projectId });
      if (emp?.data?.data) {
        dispatch(setEmployeeInfo(emp.data.data));
      }
    localStorage.setItem("project", JSON.stringify(selected));
    setSelectedCity(selected);
    setSearchParams({ projectId: selected.projectId });
  };

  // =========================
  // 3) Get permission
  // =========================
  const getPermission = async (userId: number) => {
    try {
      const res = await listPermission({ UserId: userId });
      if (res?.data?.data) {
        setPermission(res.data.data);
      }
    } catch (err) {
      setPermission([]);
    }
  };

  // =========================
  // Run đúng thứ tự
  // =========================
  useEffect(() => {
    const run = async () => {
      if (!employeeInfo?.user_id) return;
      const projects = await fetchProject(employeeInfo.user_id);
      await applyDefaultProject(projects);
      await getPermission(employeeInfo.user_id);
    };
    run();
  }, []);

  // =========================
  // On change project
  // =========================
  const onChange = async (event: any) => {
    setSelectedCity(event.value);
    localStorage.setItem("project", JSON.stringify(event.value));
    setSearchParams({ projectId: event.value.projectId });
    const emp = await infoEmployeeByStore({UserId: employeeInfo.user_id, StoreId: event.value.projectId });
    if (emp?.data?.data) {
      dispatch(setEmployeeInfo(emp.data.data));
    }
    window.location.reload();
  };

  // =========================
  // Permission helpers
  // =========================
  const permissionMap = useMemo(() => {
    return new Map(permission.map(p => [p.permission?.trim(), p]));
  }, [permission]);

  const canViewMenu = (menuName: string) => {
    const p = permissionMap.get(menuName?.trim());
    return p?.view === true || p?.all === true;
  };

  const filterSidebarByPermission = (sidebar: any[]) => {
    return sidebar
      .map(group => {
        const items = (group.items || [])
          .map((item:any) => {
            let children: any[] = [];

            if (item.items?.length) {
              children = filterSidebarByPermission([
                { items: item.items }
              ])[0]?.items || [];
            }
            const permissionKey = item.name
            ? item.name
                .trim()
                .toLowerCase()
                .normalize("NFD") // tách dấu
                .replace(/[\u0300-\u036f]/g, "") // xoá dấu
                .replace(/đ/g, "d")
                .replace(/[^a-z0-9]+/g, "_") // ký tự đặc biệt => _
                .replace(/^_+|_+$/g, "") // xoá _ đầu/cuối
            : "";
            const allow = canViewMenu(permissionKey);

            if (children.length > 0) {
              return allow || children.length
                ? { ...item, items: children }
                : null;
            }

            return allow ? item : null;
          })
          .filter(Boolean);

        return items.length ? { ...group, items } : null;
      })
      .filter(Boolean);
  };

  // =========================
  // Sidebar đã filter
  // =========================
  const sidebarFiltered = useMemo(() => {
     if ([280].includes(employeeInfo?.user_id)) {
         return sidebarModel
      } else {
         if (!permission.length) return [];
         return filterSidebarByPermission(sidebarModel);
      }
  }, [permission]);

  // =========================
  // Render
  // =========================
  return (
    <MenuProvider>
      <span className="p-float-label">
        <Dropdown
          value={selectedCity}
          onChange={onChange}
          options={data}
          optionLabel="name"
          placeholder="Chọn dữ liệu"
          className="w-full md:w-14rem p-inputtext-sm"
        />
        <label>Dữ liệu</label>
      </span>

      <ul className="layout-menu">
        {sidebarFiltered.map((item: any, i: number) => (
          <MenuSidebar
            key={i}
            item={item}
            root={true}
            index={i}
          />
        ))}
      </ul>
    </MenuProvider>
  );
}

